import Entry from './Entry';

export default function TextFieldControl(props) {
  return (
    <Entry type="text" {...props} />
  );
}
